import { Call, ApiUrl, PageParams, ParseGeneralResponse, setObjectToFormData } from './ApiUtils';
import AppConfig from '../config/AppConfig';
import { isEmpty } from '../common/Common';
import I18n from '../common/I18n';
import userStore from '../stores/UserStore';
import { dedupeRequest } from './requestCache';

export function fetchAccounts(
  orgId,
  page = 1,
  perPage = AppConfig.perPage,
  sortOrder = "ascend",
  searchText = "",
  filter = {},
  status,
  is_export = false,
  whId = null,
) {
  let url = ApiUrl(`v2/account?${PageParams(page, perPage)}`);
  if (!isEmpty(orgId)) {
    url = `${url}&org_id=${orgId}`;
  }
  // if (!isEmpty(sortOrder)) {
  //   url = `${url}&sort_order=${I18n.t(`general.sort_${sortOrder}`)}`;
  // }
  if (!isEmpty(whId)) {
    url = `${url}&warehouse_ids=${whId}`;
  }
  if (!_.isEmpty(filter) && !isEmpty(filter.sortBy) && !isEmpty(filter.sortByType)) {
     url = `${url}&sort_by=${filter.sortBy}&sort_order=${I18n.t(`general.sort_${filter.sortByType}`)}`;
  }
  if (!isEmpty(searchText) && is_export !== true) {
    url = `${url}&search_text=${encodeURIComponent(searchText)}`;
  }
  url=`${url}&is_export=${is_export}`;
  url = `${url}&operation_code=AI`;
  url = `${url}&status=${status}`;
  return Call('get', url, {}, ParseGeneralResponse, {
    responseDataKeys: { accounts: 'accounts', pagination: 'meta.pagination', file: 'file' },
  }, true);
}

export function fetchPrimaryAccountCodes(data = {}) {
  const { warehouse_ids = ""} = data
  let url = ApiUrl(`v2/account/primary_accounts?operation_code=PA&skip_wh_check=${data?.skip_wh_check === false ? false : true}`);
  if (data?.orgId && !isEmpty(data.orgId)) {
    url = `${url}&org_id=${data.orgId}`;
  }
  if(!isEmpty(warehouse_ids)){
    url = `${url}&warehouse_ids=${warehouse_ids}`;
  }
  return Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: { accounts: "accounts", pagination: "meta.pagination" },
    },
    true
  );
}

export function fetchShortFormAccounts(orgId,whId,skip_wh = false,sales_person,sales_id) {
  let url = ApiUrl("v2/account/ddl_accounts?operation_code=DA");
  if (!isEmpty(orgId)) {
    url = `${url}&org_id=${orgId}`;
  }
  if(!isEmpty(whId)){
    url = `${url}&warehouse_ids=${whId}`;
  }
  if(skip_wh){
    url = `${url}&skip_wh_check=${skip_wh}`;
  }
  if(sales_person){
    url = `${url}&sales_person=${sales_person}`;
  }
  if(sales_id){
    url = `${url}&sales_id=${sales_id}`;
  }
  
  return Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: { accounts: "accounts" },
    },
    true
  );
}
export function fetchAccount(accountId) {
  const url = ApiUrl(`v2/account/${accountId}?account_id=${accountId}&operation_code=AS`);
  return Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: {
        account: "account",
        is_primary_account: "is_primary_account",
      },
    },
    true
  );
}

export function fetchAccountShipperConfig(integration_code) {
  const organization_id = userStore.getStateValue("selectedOrg")
  const url = ApiUrl(`v2/shipper_modules/get_shipper_configuration?organization_id=${organization_id}&integration_code=${integration_code}`);
  return Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: {
        data: "",
      },
    },
    true
  );
}

export function fetchSubAccounts(accountId) {
  const url = ApiUrl(`v2/account/sub_accounts?account_id=${accountId}&operation_code=SA`);
  return Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: { accounts: "accounts" },
    },
    true
  );
}

export function saveAccount(isNew, data) {
  if (
    data.phone_number &&
    data.phone_number.length > 0 &&
    data.phone_number[0] !== "+"
  ) {
    data.phone_number = `+${data.phone_number}`;
  }
  data.operation_code = isNew ? 'AC' : 'AU';
  const formData = setObjectToFormData(data);
  const url = isNew ? ApiUrl("v2/account") : ApiUrl(`v2/account/${data.id}`);
  const method = isNew ? "post" : "put";
  return Call(method, url, formData, ParseGeneralResponse, { responseDataKeys: {account : "account"},  }, true);
}

export function generateStandardAccessorials(data) {
  data.operation_code = 'AAGSA'
  const url = ApiUrl(`v2/account_accessorials/generate_standard_accessorials`);
  return Call("post", url, data, ParseGeneralResponse, {
    responseDataKeys: {},
  });
}

export function deleteAccount(id, data = {}) {
  data.operation_code = 'AD';
  const url = ApiUrl(`v2/account/${id}`);
  return Call("delete", url, data, ParseGeneralResponse, {}, true);
}

export function setAccountConfig(data, accountId) {
  data.operation_code = 'ACNF';
  const url = ApiUrl(`v2/account/${accountId}/configuration`);
  return Call("post", url, data, ParseGeneralResponse, {
    responseDataKeys: { acct_config: "" },
  });
}

export function createAccountConfig(data) {
  data.operation_code = 'ACNF';
  const url = ApiUrl(`v2/account/update_accounts_configuration`);
  return Call("post", url, data, ParseGeneralResponse, {
    responseDataKeys: { acct_config: "" },
  });
  
}

export function fetchBulkAccountActivities(orgId, page, perPage) {
  const url = ApiUrl(
    `v2/account/bulk_accounts_config_activities?organization_id=${orgId}&page=${page}&per_page=${perPage}`
  );
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { activities: "activities", pagination: "meta.pagination", },
  });
}

export function fetchAccountConfigs(accountId, orgId, settingType = 'ACCOUNT') {
  const url = ApiUrl(
    `v2/account/${accountId}/configuration_details?organization_id=${orgId}&operation_code=ACNFD&setting_type=${settingType}`
  );
  return dedupeRequest(url, () => Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { account_configurations: "account_configurations" },
  }));
}

export function fetchAccountDetails(accountId) {
  const url = ApiUrl(`v2/account/get_account_details?account_id=${accountId}`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { account_details: "data" },
  });
}

export function fetchAccountAccessorials(accountId, visibleTo = "ALL") {
  // const url = ApiUrl(`v2/account_accessorials?account_id=${accountId}&visible_to=${visibleTo}`);
  const url = ApiUrl(
    `v2/account_accessorials/account_accessorial_collection?account_id=${accountId}&visible_to=${visibleTo}&operation_code=AAAAC`
  );
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { accessorials: "account_accessorials" },
  });
}

export function fetchAccountAccessorialWithParams(
  accountId,
  visibleTo = "ALL"
) {
  const url = ApiUrl(
    `v2/account_accessorials/account_accessorial?account_id=${accountId}&visible_to=${visibleTo}`
  );
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { accessorials: "account_accessorials" },
  });
}

export function setAccountAccessorial(data) {
  const url = ApiUrl("v2/account_accessorials");
  return Call("post", url, data, ParseGeneralResponse, {
    responseDataKeys: { accessorials: "" },
  });
}

export function setBillingConfig(data) {
  const url = ApiUrl("v2/billing/configuration");
  return Call("post", url, data, ParseGeneralResponse, {
    responseDataKeys: { acct_config: "" },
  });
}

export function fetchAccountBillingConfigs(orgId, accountId) {
  let url = ApiUrl(
    `v2/billing/configuration_details?organization_id=${orgId}&operation_code=BLCONFD`
  );
  if(!isEmpty(accountId)){
    url = `${url}&account_id=${accountId}`;
  }
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { configurations: "account_billing_configurations" },
  });
}

export function fetchAccountDeliveryZipcodes(
  orgId,
  accountId,
  use_org_delivery_zips
) {
  let url = ApiUrl(`v2/delivery_zip?org_id=${orgId}&operation_code=DZI`);
  if (!isEmpty(accountId)) {
    url = `${url}&account_id=${accountId}`;
  }
  if (!isEmpty(use_org_delivery_zips)) {
    url = `${url}&use_org_delivery_zips=${use_org_delivery_zips}`;
  }
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { dow_zipcodes: "dow_zip_codes" },
  });
}

export function saveDeliveryZipcodes(data) {
  data.operation_code = 'SWHZC';
  const url = ApiUrl("v2/delivery_zip/save_wh_zip_codes");
  return Call("post", url, data, ParseGeneralResponse);
}

export function fetchAccountDims(orgId, accountId) {
  const url = ApiUrl(
    `v2/dims?organization_id=${orgId}&account_ids=${accountId}&operation_code=DIMI`
  );
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { configurations: "dims" },
  });
}

export function saveDimValues(data, isNew) {
  data.operation_code = isNew ? 'DIMC' : 'DIMU';
  const method = isNew ? "post" : "put";
  const url = ApiUrl(`v2/dims/${isNew ? "" : data.id}`);
  return Call(method, url, data, ParseGeneralResponse, {
    responseDataKeys: { acct_config: "" },
  });
}

export function generateBol(account, org) {
  const url = ApiUrl(`v2/billing/account_bols?account_id=${account}&organization_id=${org}&operation_code=ABOLG`);
  return Call('get', url, {}, ParseGeneralResponse, {
    responseDataKeys: { response: "" },
  });
}

export function accountRestore(account, org) {
  const url = ApiUrl(`v2/account/${account}/restore_accounts?account_id=${account}&organization_id=${org}`);
  return Call('put', url, {}, ParseGeneralResponse, {
    responseDataKeys: { response: "" },
  });
}

export function copyAccount(data) {
  const url = ApiUrl("v2/account_cloning/create_acc_details");
  return Call("post", url, data, ParseGeneralResponse, {
    responseDataKeys: { account_configurations: "" , billing_zones: "" , level_of_services: "" },
  });
} 
export function uploadAccountsCsv(data) {
  const formData = setObjectToFormData(data);
  const url = ApiUrl("v2/import_accounts/create_accounts");
  return Call("post", url, formData, ParseGeneralResponse, {
    responseDataKeys: { response: "" },
  });
}

export function fetchOrgRules(organization_id) {
  const url = ApiUrl(
    `v2/organization_rules?organization_id=${organization_id}&operation_code=OCNFR`
  );
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { organization_rules: "organization_rules" },
  });
}

export function fetchAccountActivities(accountId, organization_id, page, perPage,selectedKey) {
  const url = ApiUrl(
    `v2/account/account_activities_list?account_id=${accountId}&organization_id=${organization_id}&page=${page}&per_page=${perPage}&reference=${selectedKey}`
  );
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { activities: "activities", pagination: "meta.pagination", },
  });
}

export function updateOrgRules(data) {
  const url = ApiUrl("v2/organization_rules");
  return Call("post", url, data, ParseGeneralResponse, {
    responseDataKeys: { organization_rule: "organization_rule", message: "message"},
  });
}

export function fetchOrgAccounts(orgId, whId, skip_wh = false, all_accounts = false) {
  let url = ApiUrl("v2/account/org_accounts?operation_code=DA");
  if (!isEmpty(orgId)) {
    url = `${url}&org_id=${orgId}&all_accounts=${all_accounts}`;
  }
  
  // if(all_accounts){
  //   url = `${url}&all_accounts=${all_accounts}`;
  // }

  return dedupeRequest(url, () => Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: { accounts: "accounts" },
    },
    true
  ));
}

export function fetchOrderTypeLos(orgId,account_id) {
  let url = ApiUrl(`v2/account/${account_id}/order_type_los_details?operation_code=DA`);
  if (!isEmpty(orgId)) {
    url = `${url}&org_id=${orgId}`;
  }
  
  return Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: { data: "" },
    },
    true
  );
}

export function saveOrderTypeLos(payload) {
  payload.operation_code = 'DA';
  let url = ApiUrl(`v2/account/${payload.account_id}/order_type_los?operation_code=DA`);
  return Call(
    "put",
    url,
    payload,
    ParseGeneralResponse,
    {
      responseDataKeys: { data: "" },
    },
    true
  );
}

export function fetchAccountUnits(orgId) {
  let url = ApiUrl(`v2/account/get_account_weight_unit?organization_id=${orgId}`);

  return Call(
    "get",
    url,
    {},
    ParseGeneralResponse,
    {
      responseDataKeys: { accountsUnits: "account_weight_unit_configs" },
    },
    true
  );
}

export function fetchNonBillableAccounts(orgId) {
  const url = ApiUrl(`v2/account/non_billable_accounts?org_id=${orgId}`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { accounts: "accounts" },
  });
}

export function saveQuoteDiscount(data) {
  const url = ApiUrl("v2/quote_orders/quote_discount_contracts");
  return Call("post", url, data, ParseGeneralResponse, {
    responseDataKeys: { data: "" },
  });
}

export function getQuoteDiscounts(accountId, orgId) {
  const url = ApiUrl(`v2/quote_orders/quote_discount_index?account_id=${accountId}&organization_id=${orgId}`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { data: "" },
  });
}

export function deleteQuoteDiscount(id, accountId, orgId) {
  const url = ApiUrl(`v2/quote_orders/delete_quote_discount?account_id=${accountId}&organization_id=${orgId}&quote_discount_id=${id}`);
  return Call("delete", url, {}, ParseGeneralResponse, {
    responseDataKeys: { data: "" },
  });
}

export function fetchAccActivityLogs(orgId, page = 1, perPage = 20,reference="ALL", usersList = "ALL", fromDate, toDate, searchText, accountId) {
  const url = ApiUrl(`v2/account/account_activities_list?organization_id=${orgId}&page=${page}&per_page=${perPage}&reference=${reference}&user_name=${usersList}&from_date=${fromDate}&to_date=${toDate}&description=${searchText}&account_id=${accountId}`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { data: "", pagination: "meta.pagination" },
  });
}

export function exportAccConfigs(payload) {
  const { account_id = "", organization_id = "" } = payload;
  const url = ApiUrl(`v2/export_account_settings/get_account_configurations_xlsx?account_id=${account_id}&organization_id=${organization_id}`);
  return Call("get", url, {}, ParseGeneralResponse, {
    responseDataKeys: { data: "" },
  });
}